/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportreasoninaccuratedata4Inputs */

const en_contentreportreasoninaccuratedata4 = /** @type {(inputs: Contentreportreasoninaccuratedata4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect information`)
};

const de_contentreportreasoninaccuratedata4 = /** @type {(inputs: Contentreportreasoninaccuratedata4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falsche Angaben`)
};

/**
* | output |
* | --- |
* | "Incorrect information" |
*
* @param {Contentreportreasoninaccuratedata4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportreasoninaccuratedata4 = /** @type {((inputs?: Contentreportreasoninaccuratedata4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportreasoninaccuratedata4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportreasoninaccuratedata4(inputs)
	return de_contentreportreasoninaccuratedata4(inputs)
});
export { contentreportreasoninaccuratedata4 as "contentReportReasonInaccurateData" }